module.exports = __webpack_public_path__ + "img/zhuCeZhengShuCI.2b085bbb.jpg";